import React, { useEffect, useState } from 'react';
import { string } from 'prop-types';
import { Round as ArrowBackIosIcon } from '@tamagoshi/icons/ArrowBackIos';

export default function ChevronLeft({ className, ...props }) {
    const [isClient, setIsClient] = useState(false);
    useEffect(() => {
        setIsClient(true);
    }, []);
    return isClient && <ArrowBackIosIcon {...props} className={className} />;
}

ChevronLeft.propTypes = {
    className: string,
};

ChevronLeft.defaultProps = {
    className: null,
};
